import React, { Component } from "react";
import {
  company,
  loading,
  GET,
  POST,
  PUT,
  DELETE,
  alert,
  t, // นำเข้าฟังก์ชัน t
  NavbarWarehouse
} from "../../components/CustomComponent.js"; 

// ค่าคงที่สำหรับการยิง API (ปรับให้ตรงกับ Environment ของคุณ)
export default class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_tab: "part_control",
      
      // ตัวแปรสำหรับเก็บข้อมูล Part Control API
      uid: null, // เก็บ uid ถ้ามีข้อมูลอยู่แล้ว
      field_control: {
        warehouse_id: false,
        location_id: false,
        batch_number: false,
        date: false
      }
    };
  }

  async componentDidMount() {
    await this.fetchPartControls();
  }

  // ฟังก์ชันดึงข้อมูลการตั้งค่าปัจจุบัน
  fetchPartControls = async () => {
    loading(true);
    try {
      let result = await GET("warehouse/part-controls");
      
      
      // สมมติว่า API ส่งกลับมาเป็น Object หรือ Array (ปรับตามโครงสร้าง Response จริงของคุณ)
      // ตัวอย่างนี้สมมติว่าถ้าเป็น Array จะดึงตัวแรกมาใช้งาน
      const data = Array.isArray(result) ? result[0] : (result.data ? result.data[0] : result);

      if (data && data.field_control) {
        const fields = data.field_control || [];
        this.setState({
          uid: data.uid || data.id || null, // เก็บ ID เพื่อเอาไว้ใช้ PUT หรือ DELETE
          field_control: {
            warehouse_id: fields.includes("warehouse_id"),
            location_id: fields.includes("location_id"),
            batch_number: fields.includes("batch_number"),
            date: fields.includes("date")
          }
        });
      }
    } catch (error) {
      console.error("Error fetching Part Controls:", error);
    }
    loading(false);
  };

  // ฟังก์ชันสำหรับสลับค่า Checkbox
  toggleField = (field) => {
    this.setState((prevState) => ({
      field_control: {
        ...prevState.field_control,
        [field]: !prevState.field_control[field]
      }
    }));
  };

  // ฟังก์ชันสำหรับบันทึกข้อมูล (POST หรือ PUT)
  savePartControls = async () => {
    loading(true);
    const { uid, field_control } = this.state;
    
    // แปลงจาก Object ให้อยู่ในรูปแบบ Array ของ string เฉพาะตัวที่เป็น true
    const activeFields = Object.keys(field_control).filter(key => field_control[key]);

    const body = {
      company_id: company?.id || "",
      field_control: activeFields
    };

    try {
      let result = !uid
              ? await POST("warehouse/part-controls", body)
              : await PUT("warehouse/part-controls/" + uid, body);
      

      if (result.status) {
        alert("#", "success", t("save_success"));
      } else {
        alert(t("save_error_msg"));
      }
    } catch (error) {
      console.error("Error saving Part Controls:", error);
      alert(t("cannot_connect_server"));
    }
    loading(false);
  };
 

  render() {
    const { active_tab, field_control, uid } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarWarehouse />
        <div className="body p-4 mt-3">
          
          {/* Header Section */}
          <div className="mb-4">
            <h3 className="fw-bold mb-1 text-dark">{t("system_settings")}</h3>
            <div className="text-secondary text-14">{t("system_settings_desc")}</div>
          </div>

          <div className="row g-4">
            
            {/* Left Sidebar Menu */}
            <div className="col-lg-3">
              <div className="bg-white rounded-4 shadow-sm p-3 h-100">
                <h6 className="fw-bold text-dark mb-3 px-2 pt-2">{t("settings")}</h6>
                <div className="d-flex flex-column gap-1">
                  <div 
                    className={`d-flex align-items-center p-3 rounded-3 pointer transition-hover ${active_tab === 'part_control' ? 'bg-primary-light text-primary fw-bold' : 'text-secondary hover-bg-light'}`}
                    onClick={() => this.setState({ active_tab: 'part_control' })}
                  >
                    <span className="icon me-3 text-16 wpx-20 text-center">{"\uf2c1"}</span> {t("part_control")}
                  </div>
                </div>
              </div>
            </div>

            {/* Right Content Area */}
            <div className="col-lg-9">
              {active_tab === 'part_control' && (
                <div className="d-flex flex-column gap-4">
                  
                  {/* Part Control Settings Card */}
                  <div className="card border-0 rounded-4 shadow-sm p-4 bg-white">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 className="fw-bold text-dark mb-0">{t("part_control_settings_title")}</h5>
                    </div>
                    
                    <div className="d-flex flex-column gap-0">
                      
                      {/* Warehouse Toggle */}
                      <div className="d-flex justify-content-between align-items-center py-3 border-bottom border-light">
                        <div>
                          <div className="fw-bold text-dark text-14 mb-1">{t("warehouse")}</div>
                          <div className="text-secondary text-12">{t("enable_warehouse_control_desc")}</div>
                        </div>
                        <input 
                          type="checkbox" 
                          className="form-check-input pointer" 
                          style={{ width: '20px', height: '20px' }}
                          checked={field_control.warehouse_id}
                          onChange={() => this.toggleField('warehouse_id')}
                        />
                      </div>

                      {/* Location Toggle */}
                      <div className="d-flex justify-content-between align-items-center py-3 border-bottom border-light">
                        <div>
                          <div className="fw-bold text-dark text-14 mb-1">{t("location")}</div>
                          <div className="text-secondary text-12">{t("enable_location_control_desc")}</div>
                        </div>
                        <input 
                          type="checkbox" 
                          className="form-check-input pointer" 
                          style={{ width: '20px', height: '20px' }}
                          checked={field_control.location_id}
                          onChange={() => this.toggleField('location_id')}
                        />
                      </div>

                      {/* Batch Number Toggle */}
                      <div className="d-flex justify-content-between align-items-center py-3 border-bottom border-light">
                        <div>
                          <div className="fw-bold text-dark text-14 mb-1">{t("batch_number")}</div>
                          <div className="text-secondary text-12">{t("enable_batch_control_desc")}</div>
                        </div>
                        <input 
                          type="checkbox" 
                          className="form-check-input pointer" 
                          style={{ width: '20px', height: '20px' }}
                          checked={field_control.batch_number}
                          onChange={() => this.toggleField('batch_number')}
                        />
                      </div>

                      {/* Date Toggle */}
                      <div className="d-flex justify-content-between align-items-center py-3">
                        <div>
                          <div className="fw-bold text-dark text-14 mb-1">{t("date")}</div>
                          <div className="text-secondary text-12">{t("enable_date_control_desc")}</div>
                        </div>
                        <input 
                          type="checkbox" 
                          className="form-check-input pointer" 
                          style={{ width: '20px', height: '20px' }}
                          checked={field_control.date}
                          onChange={() => this.toggleField('date')}
                        />
                      </div>

                    </div>
                  </div>

                  {/* Bottom Action Buttons */}
                  <div className="d-flex justify-content-end gap-3 mt-2">
                    <button 
                      className="btn btn-white border px-4 py-2 rounded-3 text-dark fw-bold shadow-sm bg-white"
                      onClick={this.fetchPartControls}
                    >
                      {t("cancel")}
                    </button>
                    <button 
                      className="btn btn-primary px-4 py-2 rounded-3 fw-bold d-flex align-items-center shadow-sm" 
                      style={{ backgroundColor: '#2563eb', borderColor: '#2563eb' }}
                      onClick={this.savePartControls}
                    >
                      <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button>
                  </div>

                </div>
              )}
            </div>

          </div>
        </div>
      </div>
    );
  }
}